// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.9974 12.9167H6.2474C5.08443 12.9167 4.50294 12.9167 4.02978 13.0602C2.96444 13.3834 2.13076 14.217 1.8076 15.2824C1.66406 15.7555 1.66406 16.337 1.66406 17.5M15.8307 17.5V12.5M13.3307 15H18.3307M12.0807 6.25C12.0807 8.32107 10.4018 10 8.33073 10C6.25966 10 4.58073 8.32107 4.58073 6.25C4.58073 4.17893 6.25966 2.5 8.33073 2.5C10.4018 2.5 12.0807 4.17893 12.0807 6.25Z"
    />
  </svg>
);
const IconUserPlus = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUserPlus;
